import 'css-chunksrc/client/pages/projectPage/documentsPage/documentsPage/dropPreview/styles.scss';export default {
  "dropPreview": "_dropPreview_bgk6p_1",
  "icon": "_icon_bgk6p_17",
  "message": "_message_bgk6p_22"
};